import React, { createContext, useContext, useState } from "react";
import dayjs from "dayjs";

const CounsellorDateContext = createContext({
    filterDate: dayjs(),
    setFilterDate: () => {},
});

export const useCounsellorDate = () => useContext(CounsellorDateContext);

export default CounsellorDateContext;
